import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateLogisticBoxInput,
    UpdateLogisticBoxInput,
    LogisticBox,
    ModelLogisticBoxConditionInput,
    ModelLogisticBoxFilterInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class LogisticBoxService {
    private amplifyClient = generateClient();
    constructor() {}

    async getLogisticBox(id: string): Promise<LogisticBox> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getLogisticBox,
                    variables: { id }
                })
            ).data.getLogisticBox;
            if (data) return data as LogisticBox;
        } catch (error) {
            console.error('Error finding LogisticBox:', error);
            return null;
        }
    }

    async listLogisticBoxes(
        filter: ModelLogisticBoxFilterInput = null
    ): Promise<LogisticBox[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listLogisticBoxes,
                    variables: {
                        filter
                    }
                })
            ).data.listLogisticBoxes.items;
            if (data) return data as LogisticBox[];
        } catch (error) {
            console.error('Error finding LogisticBoxes:', error);
            return null;
        }
    }

    async listAllLogisticBoxes(
        pageLimit: number = 100
    ): Promise<LogisticBox[]> {
        const boxes: LogisticBox[] = [];
        let nextToken: string | null = null;

        try {
            do {
                const response = (
                    await this.amplifyClient.graphql({
                        query: queries.listLogisticBoxes,
                        variables: {
                            limit: pageLimit,
                            nextToken
                        }
                    })
                ).data.listLogisticBoxes;
                boxes.push(...((response?.items ?? []) as LogisticBox[]));
                nextToken = response?.nextToken ?? null;
            } while (nextToken !== null);
            return boxes;
        } catch (error) {
            console.error('Error finding LogisticBoxes:', error);
            return [];
        }
    }

    async createLogisticBoxes(
        input: CreateLogisticBoxInput
    ): Promise<LogisticBox> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createLogisticBox,
                    variables: {
                        input
                    }
                })
            ).data.createLogisticBox;
            if (date) return date as LogisticBox;
        } catch (error) {
            console.error('Error creating LogisticBox:', error);
            return null;
        }
    }

    async updateLogisticBoxes(
        input: UpdateLogisticBoxInput
    ): Promise<LogisticBox> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.updateLogisticBox,
                    variables: {
                        input
                    }
                })
            ).data.updateLogisticBox;
            if (date) return date as LogisticBox;
        } catch (error) {
            console.error('Error creating LogisticBox:', error);
            return null;
        }
    }
}
